import React from 'react'
import RegistrationStatus from './registration-status'
import { StatusesContainer, Access } from 'components/search/result-card'

export default function Statuses({ hit }) {
  return (
    <StatusesContainer>
      <Access hit={hit} />
      <RegistrationStatus hit={hit} />
    </StatusesContainer>
  )
}
